import { configureStore } from "@reduxjs/toolkit";
import fixturesReducer from "./slices/fixturesSlice";
import gameProviderReducer from "./slices/gameProviderSlice";
import userLevelReducer from "./slices/userLevelSlice";
import versusGamesReducer from "./slices/versusGamesSlice";

export const store = configureStore({
	reducer: {
		versusGames: versusGamesReducer,
		gameProvider: gameProviderReducer,
		userLevel: userLevelReducer,
		fixtures: fixturesReducer,
	},
});
